export default __webpack_public_path__ + "static/company-masthead-mobile-20778c0465a2592e643cddb45d53d9c7.png";